// src/api/lookup.ts
import { API_URL } from './config'

export interface PessoaEncontrada {
  registrationUid: string
  credentialCode: string | null
  nome: string
  documentoMascarado: string | null
  tipoDocumento: 'cpf' | 'cnpj' | 'estrangeiro' | null
  conselhoProfissional: string | null
  estadoUf: string | null
  empresa: string | null
  jaCredenciado: boolean
  ingressos: Array<{ tipo: string; familia: string; status: string }>
}

export interface ResultadoBusca {
  termo: string
  tipoDetectado: 'cpf' | 'cnpj' | 'credencial' | 'ingresso' | 'email' | 'nome' | 'vazio'
  total: number
  /** Quando verdadeiro, a tela DEVE pedir escolha em vez de seguir com o primeiro. */
  requerSelecao: boolean
  resultados: PessoaEncontrada[]
}

/**
 * Busca um participante pelo documento digitado no totem.
 *
 * Devolve lista, nunca um único registro: um CNPJ de empresa que inscreveu vários
 * funcionários retorna todos eles, e escolher automaticamente entregaria o crachá de
 * outra pessoa — com o QR de outra pessoa.
 */
export async function buscarPessoas(termo: string): Promise<ResultadoBusca> {
  const base = API_URL.replace(/\/+$/, '')
  const resp = await fetch(`${base}/people/lookup?q=${encodeURIComponent(termo)}`)
  if (!resp.ok) throw new Error(`Falha na busca (${resp.status})`)
  return resp.json()
}

/** URL da folha de impressão do crachá, renderizada pelo servidor. */
export function urlDoCracha(credentialCode: string): string {
  const base = API_URL.replace(/\/+$/, '')
  return `${base}/badge/${encodeURIComponent(credentialCode)}`
}
